import React from 'react';
import { bool, func, string } from 'prop-types';
import { Translate } from '@material-ui/icons';
import classNames from 'classnames';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles/styles.module.scss';

const OriginalLanguageButton = ({ active, handleClick, eventSource }) => {
  const reportEventAndHandleClick = e => {
    _gaq.push(['_trackEvent', 'Show Translation', eventSource, active ? 'active' : 'inactive']);
    handleClick(e);
  };

  const title = active ? StringConstantsMixin.strings.SHOW_ORIGINAL : StringConstantsMixin.strings.SHOW_TRANSLATION;

  return (
    <button className={classNames(`${styles.button}`, { [`${styles.active}`]: active })} title={title} onClick={reportEventAndHandleClick}>
      <Translate className={styles.translateIcon} />
    </button>
  );
};

OriginalLanguageButton.propTypes = {
  active: bool,
  handleClick: func.isRequired,
  eventSource: string
};

OriginalLanguageButton.defaultProps = {
  active: false,
  eventSource: ''
};

export default OriginalLanguageButton;
